import { RELATED_SCHEDULES_MIN_WIDTH } from './row/job/relatedSchedules/constants';

export const FOREMAN_COLUMN_WIDTH = 160;

export const CALENDAR_BORDERS = 2;

const DAY_COLUMN_SPACING = 22 + 16 + 5;

export const MIN_DAY_COLUMN_WIDTH = RELATED_SCHEDULES_MIN_WIDTH + DAY_COLUMN_SPACING;

export const MIN_VISIBLE_DAYS = 5;

export const MIN_VISIBLE_DAYS_WITH_COLLAPSED = 4;

export const COLLAPSED_DAY_COLUMN_WIDTH = 40;
